import { Box, Text, useTheme } from '@ltvco/refresh-lib/theme';

export function SeatReportsPausedNotice() {
  const { palette } = useTheme();

  return (
    <Box
      role="alert"
      sx={{
        p: 1.5,
        borderRadius: 1,
        border: `1px solid ${palette.warning.main}`,
        backgroundColor: palette.warning.light,
      }}
    >
      <Text variant="body2" sx={{ fontWeight: 700 }}>
        Reports are temporarily paused
      </Text>
      <Text variant="body2">
        Your plan administrator's account needs attention, so new reports are
        unavailable right now. Please reach out to your plan administrator to
        restore access.
      </Text>
    </Box>
  );
}
